<div class="container">
    <div class="row vh-100 align-items-center">
        <div class="col-md-6 text-center">
            <div class="row mb-5">
                <div class="col-12">
                    <h2>Beyondi's <span class="text-primary">MTOS</span></h2>
                    <h2>
                        <span class="text-primary">M</span>ulti
                        <span class="text-primary">T</span>oken
                        <span class="text-primary">O</span>perating
                        <span class="text-primary">S</span>ystem
                    </h2>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <p>
                        Create and operate your own custom ERC20 tokens and
                        crowdsales. <br />
                        Provide your customers an easy to use website with all
                        related crowdsale info. <br />Stay in touch with the
                        latest advances in crypto.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-10 offset-1">
                    <ngx-gallery
                        [options]="galleryOptions"
                        [images]="screenshots"
                        class="ngx-gallery"
                    ></ngx-gallery>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row mb-2">
                <div class="col-4">
                    <label for="firstName" class="mb-1"> First name </label>
                    <input
                        fullWidth
                        nbInput
                        name="firstName"
                        type="text"
                        [(ngModel)]="firstName"
                    />
                </div>
                <div class="col-4">
                    <label for="lastName" class="mb-1"> Last name </label>
                    <input
                        fullWidth
                        nbInput
                        name="lastName"
                        type="text"
                        [(ngModel)]="lastName"
                    />
                </div>
                <div class="col-4">
                    <label for="email" class="mb-1"> E-mail address </label>
                    <input
                        fullWidth
                        nbInput
                        name="email"
                        type="email"
                        [(ngModel)]="email"
                    />
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-4">
                    <label for="companyName" class="mb-1"> Company name </label>
                    <input
                        fullWidth
                        nbInput
                        name="companyName"
                        type="text"
                        [(ngModel)]="companyName"
                    />
                </div>
                <div class="col-4">
                    <label for="companyRole" class="mb-1"> Company role </label>
                    <input
                        fullWidth
                        nbInput
                        name="companyRole"
                        type="text"
                        [(ngModel)]="companyRole"
                    />
                </div>
                <div class="col-4">
                    <label for="companyWebsite" class="mb-1">
                        Company website
                    </label>
                    <input
                        fullWidth
                        nbInput
                        name="companyWebsite"
                        type="text"
                        [(ngModel)]="companyWebsite"
                    />
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-6">
                    <label for="reference" class="mb-1">
                        Where did you hear about us?
                    </label>
                    <input
                        fullWidth
                        nbInput
                        name="reference"
                        type="text"
                        [(ngModel)]="reference"
                    />
                </div>
                <div class="col-6">
                    <label for="demoDate" class="mb-1">
                        Desired date of the demo
                    </label>
                    <input
                        fullWidth
                        nbInput
                        placeholder="Select a date and time"
                        [nbDatepicker]="datetimepicker"
                        [(ngModel)]="desiredDate"
                        name="demoDate"
                    />
                    <nb-date-timepicker #datetimepicker></nb-date-timepicker>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-12">
                    <label for="demoPurpose" class="mb-1"
                        >Purpose of the demo</label
                    >
                    <textarea
                        nbInput
                        name="demoPurpose"
                        fullWidth
                        rows="10"
                        [(ngModel)]="demoPurpose"
                    ></textarea>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <button
                        [disabled]="
                            !firstName ||
                            !lastName ||
                            !email ||
                            !companyName ||
                            !companyRole ||
                            !companyWebsite ||
                            !reference ||
                            !desiredDate ||
                            !demoPurpose
                        "
                        fullWidth
                        nbButton
                        size="medium"
                        status="success"
                        (click)="onApplyForDemo()"
                    >
                        APPLY FOR A DEMO
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
